import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const CustomerInvoiceCountPage = ({ data, onUpdate }) => {
  const [customerInvoiceCount, setCustomerInvoiceCount] = useState(data.customerInvoiceCount || "");
  const [fieldErrors, setFieldErrors] = useState({
    customerInvoiceCount: ''
  });

  // Update parent component when data changes
  useEffect(() => {
    onUpdate({
      customerInvoiceCount
    });
  }, [customerInvoiceCount]);

  // Handle count selection
  const handleCountChange = (count) => {
    setCustomerInvoiceCount(count);
    setFieldErrors(prev => ({
      ...prev,
      customerInvoiceCount: ''
    }));
    
    // Scroll to the Next button after selection
    setTimeout(() => {
      scrollTo('wizard-navigation');
    }, 100);
  };

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // Scroll to the element with some offset from the top
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  };

  const countOptions = [
    {
      id: 'less-than-50',
      value: '<50',
      label: 'Less than 50',
      description: 'Small volume customer invoicing'
    },
    {
      id: '50-200',
      value: '50-200',
      label: '50 - 200',
      description: 'Medium volume customer invoicing'
    },
    {
      id: '200-500',
      value: '200-500',
      label: '200 - 500',
      description: 'High volume customer invoicing'
    },
    {
      id: 'more-than-500',
      value: '>500',
      label: 'More than 500',
      description: 'Very high volume customer invoicing'
    },
    {
      id: 'dont-know',
      value: 'dont-know',
      label: 'I don\'t know',
      description: 'We can help you determine the right setup'
    }
  ];

  return (
    <div className="wizard-page customer-invoice-count-page">
      <div className="page-header">
        <h2>How many <b><u>customer invoices</u></b> will you send <b><u>every month</u></b>?</h2>
        {data.companyCount && data.companyCount > 1 ? <p>Please specify the <b><u>total count</u></b> for all {data.companyCount} companies.</p> : ""}
        <p>This helps us understand your needs and recommend the optimal configuration. You will always be able to change this later.</p>
      </div>

      <div className="form-content" id="customer-invoice-count-form">
        <div className="form-group">
          <div className="count-options">
            {countOptions.map(option => (
              <div key={option.id} className="count-option">
                <input
                  type="radio"
                  id={option.id}
                  name="customerInvoiceCount"
                  value={option.value}
                  checked={customerInvoiceCount === option.value}
                  onChange={() => handleCountChange(option.value)}
                  className="count-radio"
                />
                <label htmlFor={option.id} className="count-label">
                  <div className="count-content">
                    <div className="count-title">{option.label}</div>
                  </div>
                </label>
              </div>
            ))}
          </div>

          {fieldErrors.customerInvoiceCount && (
            <span className="field-error">{fieldErrors.customerInvoiceCount}</span>
          )}
        </div>
      </div>
    </div>
  );
};

CustomerInvoiceCountPage.propTypes = {
  data: PropTypes.shape({
    companyCount: PropTypes.string,
    customerInvoiceCount: PropTypes.string
  }).isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default CustomerInvoiceCountPage;
